var React = require('react');

function SauceIconForward (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M40 30v20L0 70V50l40-20Z","fill":"#3DDC91","key":0}),React.createElement("path",{"d":"M0 10v20l40 20V30L0 10ZM80 30v20L40 70V50l40-20Z","fill":"#3DDC91","key":1}),React.createElement("path",{"d":"M40 10v20l40 20V30L40 10Z","fill":"#3DDC91","key":2})]);
}

SauceIconForward.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = SauceIconForward;

SauceIconForward.default = SauceIconForward;
